import { FC } from 'react';
import { Button, Card, Col, Form, Input, Row } from "antd";
import * as React from "react";

import { useSearchParams } from 'react-router-dom';
import SelectRoleField from '../fields/select-role-field';
import SelectVoteStatusField from '../fields/select-vote-status-field';

interface Prop {
	onFinish: (data: any) => any
}

const UserFilter: FC<Prop> = ({ onFinish }) => {
	const [form] = Form.useForm();
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		form.setFieldValue("role", searchParams.get("role"))
		form.setFieldValue("voteStatus", searchParams.get("voteStatus"))
		onFinish(form.getFieldsValue())
	}, [])

	return (
		<Card style={{ marginBottom: "16px" }}>
			<Form form={form} onFinish={onFinish} layout="horizontal" autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24} md={12} xl={6}  >
						<Form.Item name="mobile" label="موبایل">
							<Input allowClear />
						</Form.Item>
					</Col>

					<Col xs={24} md={12} xl={6}  >
						<Form.Item name="role" label="نقش">
							<SelectRoleField allowClear />
						</Form.Item>
					</Col>

					<Col xs={24} md={12} xl={6}  >
						<Form.Item name="voteStatus" label="بازخورد" 	>
							<SelectVoteStatusField allowClear />
						</Form.Item>
					</Col>

					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">جستجو</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	)
}

export default UserFilter;
